// Dummy data for Menu Oversight tabs

export interface Promotion {
  id: string;
  title: string;
  description: string;
  validUntil: string;
  submitted: string;
  restaurant: string;
  status: "pending_approval" | "active" | "rejected" | "expired";
}

export interface FlaggedItem {
  id: string;
  restaurant: string;
  suspensionReason: string;
  suspensionDate: string;
  type: "menu_item" | "promotion" | "content";
}

export const promotionsData: Promotion[] = [
  {
    id: "PROMO001",
    title: "30% Off Weekend Special",
    description: "Get 30% off on all rice dishes this weekend",
    validUntil: "Jan 28, 2025",
    submitted: "1hr ago",
    restaurant: "The Place Restaurant Gbagada",
    status: "pending_approval"
  },
  {
    id: "PROMO002",
    title: "30% Off Weekend Special",
    description: "Get 30% off on all rice dishes this weekend",
    validUntil: "Jan 28, 2025",
    submitted: "1hr ago",
    restaurant: "The Place Restaurant Gbagada",
    status: "active"
  },
  {
    id: "PROMO003",
    title: "Buy 1 Get 1 Free Pizza",
    description: "Order any large pizza and get a second one free",
    validUntil: "Feb 15, 2025",
    submitted: "2hrs ago",
    restaurant: "Pizza Palace",
    status: "pending_approval"
  },
  {
    id: "PROMO004",
    title: "Lunch Special Deal",
    description: "Complete lunch meal at discounted prices",
    validUntil: "Jan 20, 2025",
    submitted: "3 days ago",
    restaurant: "Quick Bite",
    status: "expired"
  }
];

export const flaggedItemsData: FlaggedItem[] = [
  {
    id: "FLAG001",
    restaurant: "FOOD PLACE",
    suspensionReason: "Price mismatch reported",
    suspensionDate: "29 - 09- 2026",
    type: "menu_item"
  },
  {
    id: "FLAG002",
    restaurant: "Spice Garden",
    suspensionReason: "Inappropriate content in promotion",
    suspensionDate: "25 - 09- 2026",
    type: "promotion"
  },
  {
    id: "FLAG003",
    restaurant: "Golden Spoon",
    suspensionReason: "False advertising claims",
    suspensionDate: "20 - 09- 2026",
    type: "content"
  }
];